import React, {Component} from 'react'
import MaterialIcon from "material-icons-react";

export default class EmptyTable extends Component {
    render() {
        return (
            <div className="w-100 centered-container h-200">
                <div className="centered">
                    <div className="block ">
                        <div className="w-100 centered"><MaterialIcon size="42px" icon="grid_off"/></div>
                        <div className="w-100 centered">
                            { !this.props.text ? null : <bold>{this.props.text}</bold> }
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/OgaTables/EmptyTable.jsx